import React from 'react'
import init1 from '../images/init-1.jpg'
import init2 from '../images/ini-2.jpg'
import init3 from '../images/init-3.jpg'
import '../style/init.css'

const Init = () => {
    return (
        <>
            <div className='container' >
                <div className='container'>
                    <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '50px', marginBottom:'50px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                        <h3 style={{ padding: '7px', color: 'rgb(13 92 126)' }}>WISH TO ACHIEVE RAPID GROWTH?</h3>
                    </div>
                </div>
                <div className='row' style={{ flexDirection: 'row-reverse' }} id='rM'>
                    <div className='col' style={{ textAlign: 'center', marginTop: "50px" }} >
                        <img id='imgInit' src={init1} style={{ borderRadius: '400px', boxShadow: "0px 1px 10px 10px lightgray", marginTop: '15px' }} alt="client" />
                    </div>
                    <div className='col' id='rmarg'>
                        <h3 style={{ color: '#00415d', marginTop: "60px" }}>SERVICE SEEKER</h3>
                        <h4 style={{ fontSize: '15px', marginTop: '20px', color: "#881E20" }}>Seeking a reliable partner with a solid foundation to manage various operational aspects.</h4>
                        <ul style={{ fontSize: '15px', marginTop: '20px', listStyleType: 'none', paddingLeft: '0px' }}>
                            <li>✔️ Enables you to concentrate on core business activities.</li>
                            <hr />
                            <li>✔️ Looks for a partner with essential subject matter expertise.</li>
                            <hr />
                            <li>✔️ Requires a broad array of services at competitive rates.</li>
                            <hr />
                            <li>✔️ Assurance of efficient service delivery from a corporate standpoint.</li>
                        </ul>
                        <div className='btnTalk' >
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ marginTop: '15px' }} id='rM'>
                    <div className='col' style={{ textAlign: 'center', marginTop: "50px" }} >
                        <img id='imgInit' src={init2} style={{ borderRadius: '400px', boxShadow: "0px 1px 10px 10px lightgray", marginTop: '25px' }} alt="client" />
                    </div>
                    <div className='col' id='rmarg'>
                        <h3 style={{ color: '#00415d', marginTop: "60px" }}>CONSULTANT</h3>
                        <h4 style={{ fontSize: '15px', marginTop: '20px', color: "#881E20" }}>A domain expert and governance mentor bridging the gap between service seekers and providers.</h4>
                        <ul style={{ fontSize: '15px', marginTop: '20px', listStyleType: 'none', paddingLeft: '0px' }}>
                            <li>✔️ A verified and dependable authority in the field.</li>
                            <hr />
                            <li>✔️ A recognized expert in their specialized area.</li>
                            <hr />
                            <li>✔️ Acts as a mediator between service seekers and providers.</li>
                            <hr />
                            <li>✔️ Guarantees successful project allocation, oversight, and execution. </li>
                        </ul>
                        <div className='btnTalk' >
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ flexDirection: 'row-reverse', marginTop:'0px' }} id='rM'>
                    <div className='col' style={{ textAlign: 'center', marginTop: "50px" }} >
                        <img id='imgInit' src={init3} style={{ borderRadius: '400px', boxShadow: "0px 1px 10px 10px lightgray", marginTop: '15px' }} alt="client" />
                    </div>
                    <div className='col' id='rmarg'>
                        <h3 style={{ color: '#00415d', marginTop: "60px" }}>SERVICE PROVIDER</h3>
                        <h4 style={{ fontSize: '15px', marginTop: '20px', color: "#881E20" }}>In need of a trustworthy partner with strong principles to drive business growth and efficiency.</h4>
                        <ul style={{ fontSize: '15px', marginTop: '20px', listStyleType: 'none', paddingLeft: '0px' }}>
                            <li>✔️ Has available capacity for new projects.</li>
                            <hr />
                            <li>✔️ Seeks immediate, qualified leads that match business size.</li>
                            <hr />
                            <li>✔️ Facing challenges with the high cost of lead generation.</li>
                            <hr />
                            <li>✔️ Assurance of secure payments from a corporate perspective.</li>
                        </ul>
                        <div className='btnTalk' >
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Init
